import stickerShineImg from './single_shine.png';
import './StickerShine.css';

/** Rotating sticker shine — single_shine.png, scaled → 763×735. */
export function StickerShine() {
  return (
    <img
      className="sticker-reward-shine"
      src={stickerShineImg}
      alt=""
      draggable={false}
      aria-hidden
    />
  );
}
